// Anti-gaming thresholds — single source of truth for the rules baked
// into migration 0053's check_achievements + validate_visit_insert.
// Keep these in sync with the migration if either changes.

/** Minimum cut duration (in minutes) for a visit to count toward
 *  Cuts / Clients / Revenue / Transformations / Timekeeper achievements
 *  AND for the visits trigger to bump the streak. Visits below this
 *  threshold still save and still appear in dashboards / EOD / client
 *  gallery — they just don't earn badge progress. Designed to make a
 *  tap-and-save fake cut not pay off. */
export const MIN_REAL_CUT_MIN = 5;

/** Per-UTC-day cap on visits that count toward visit-based achievements.
 *  Realistic chair output rarely exceeds 15/day; the cap binds only on
 *  attempted spam. Cuts above the 20th per day still save normally. */
export const ACH_MAX_DAILY_VISITS = 20;

/** Per-visit cap on Revenue achievement contribution, in cents. A
 *  $10,000 fake cut still saves and shows real $$ on dashboards but
 *  contributes only $500 toward the Revenue badge. */
export const ACH_MAX_REVENUE_PER_VISIT_CENTS = 50_000;

/** Per-visit cap on Timekeeper achievement contribution, in minutes.
 *  Covers ~99% of legitimate hair services (cuts, color, styling, most
 *  braids/locs); the rare 4-hour install gets capped at 2 hrs. */
export const ACH_MAX_TIMEKEEPER_PER_VISIT_MIN = 120;

/** Minimum recording duration (in seconds) for a transformation video
 *  clip to be saved AND for the stitched output to be eligible for
 *  social platforms — Reels and Facebook Reels reject anything under 3s,
 *  so 3s is the binding floor. Enforced both at capture time (Save
 *  button disabled below this) and at stitch time (output is padded
 *  with a freeze-frame extension if it would otherwise come in shorter
 *  — safety net for legacy clips, edge cases, or future rule changes). */
export const MIN_VIDEO_CAPTURE_SEC = 3;

/** Maximum recording duration (in seconds) for a transformation video
 *  clip AND for the stitched output. 60s is the binding ceiling across
 *  the major platforms — Instagram Stories' per-segment cap, YouTube
 *  Shorts' default cap. Reels (90s), Facebook Reels (90s), and TikTok
 *  (10 min) all accept 60s comfortably. Saves stay reasonably small
 *  for sharing and avoids runaway gaming via long-recording exploits. */
export const MAX_VIDEO_CAPTURE_SEC = 60;
